/* ==========================================================================
   Kankatala product rows — snippets/kankatala-product-row.liquid
   <kankatala-product-row>: thin progress line that follows the horizontal
   scroll, and mouse drag-to-scroll on desktop (no arrows). The rows are
   injected later by Prestige's <product-recommendations> /
   <recently-viewed-products>, so this is a custom element: it initialises
   itself whenever it is connected. Safe to load more than once.
   ========================================================================== */
(function () {
  'use strict';

  if (window.customElements.get('kankatala-product-row')) return;

  var DRAG_THRESHOLD = 5;

  class KankatalaProductRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-kk-row-track]');
      this.progress = this.querySelector('[data-kk-row-progress]');
      this.fill = this.querySelector('[data-kk-row-progress-fill]');
      if (!this.track) return;

      this.abort = new AbortController();
      var signal = this.abort.signal;
      var update = this.update.bind(this);

      this.track.addEventListener('scroll', update, { passive: true, signal: signal });
      window.addEventListener('resize', update, { signal: signal });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
      }

      this.track.addEventListener('pointerdown', this.onPointerDown.bind(this), { signal: signal });
      // A drag must not open the product under the pointer
      this.track.addEventListener('click', function (event) {
        if (this.dragged) {
          event.preventDefault();
          event.stopPropagation();
          this.dragged = false;
        }
      }.bind(this), { capture: true, signal: signal });

      update();
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    update() {
      if (!this.progress || !this.fill) return;
      var track = this.track;
      var overflow = track.scrollWidth - track.clientWidth;
      this.progress.hidden = overflow <= 1;
      if (overflow <= 1) return;

      var barWidth = this.progress.clientWidth;
      var fillWidth = Math.max(barWidth * track.clientWidth / track.scrollWidth, 24);
      var ratio = Math.min(Math.max(track.scrollLeft / overflow, 0), 1);
      this.fill.style.width = fillWidth + 'px';
      this.fill.style.transform = 'translateX(' + ((barWidth - fillWidth) * ratio) + 'px)';
    }

    onPointerDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      var track = this.track;
      if (track.scrollWidth <= track.clientWidth) return;

      var startX = event.clientX;
      var startScroll = track.scrollLeft;
      var moved = false;
      this.dragged = false;

      var onMove = function (moveEvent) {
        var dx = moveEvent.clientX - startX;
        if (!moved && Math.abs(dx) < DRAG_THRESHOLD) return;
        if (!moved) {
          moved = true;
          track.classList.add('is-dragging');
        }
        track.scrollLeft = startScroll - dx;
      };

      var onUp = function () {
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        if (moved) {
          // Swallow the click that follows this pointerup only (a drag released outside the row has none)
          this.dragged = true;
          setTimeout(function () { this.dragged = false; }.bind(this), 0);
          track.classList.remove('is-dragging');
          // Let scroll-snap settle on the nearest card
          track.scrollBy({ left: 0 });
        }
      }.bind(this);

      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
    }
  }

  window.customElements.define('kankatala-product-row', KankatalaProductRow);
})();
